/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type expiringTradePromoRule_QueryVariables = {
    userId: string;
    promoCodes?: ReadonlyArray<string | null> | null;
};
export type expiringTradePromoRule_QueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly expiringPromotion: {
                readonly code: string | null;
            } | null;
            readonly tradeFirmRewards: {
                readonly expiringPromoSegment: {
                    readonly expiringSegmentCode: string | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type expiringTradePromoRule_Query = {
    readonly response: expiringTradePromoRule_QueryResponse;
    readonly variables: expiringTradePromoRule_QueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "promoCodes",
    "type": "[String]",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "daysToExpiration",
    "value": 14
  },
  {
    "kind": "Variable",
    "name": "promoCodes",
    "variableName": "promoCodes"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "tradeFirmRewards",
  "storageKey": null,
  "args": null,
  "concreteType": "TradeFirmRewards",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "expiringPromoSegment",
      "storageKey": null,
      "args": null,
      "concreteType": "expiringPromoSegmentType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "expiringSegmentCode",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "expiringTradePromoRule_Query",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "expiringPromotion",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "Promotion",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "expiringTradePromoRule_Query",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "expiringPromotion",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "Promotion",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/)
                ]
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "expiringTradePromoRule_Query",
    "id": "ferrum/237.0.0-2019-10-15T13:09:02.443Z/expiringTradePromoRule_Query",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'bafdb945c161251acb62c1579d129c17';
export default node;
